import { InfoIcon } from 'lucide-react';
import Link from 'next/link';

function CaveatBanner() {
    return (
        <div className='flex items-start text-xs leading-4 text-[#9C6011] md:mx-2 md:mb-2 md:rounded-md md:px-3 md:pb-2.5 md:text-amber-900'>
            <InfoIcon size={16} className='mr-1 hidden shrink-0 text-white md:block' strokeWidth={2} fill='#9C6011' />
            <p>
                <span className='md:font-semibold'>Caveat —</span> a lower API response time for broker A vs broker B does not mean orders fired through
                broker A will be executed first.{' '}
                <span className='md:hidden'>
                    <Link
                        href='https://algotest.in/blog/broker-speedtest-algotest/'
                        className='underline underline-offset-2'
                        target='_blank'>
                        See here
                    </Link>{' '}
                    for more details.
                </span>
                <span className='hidden md:inline'>
                    See{' '}
                    <Link
                        href='https://algotest.in/blog/broker-speedtest-algotest/'
                        className='underline underline-offset-2 hover:text-amber-950'
                        target='_blank'>
                        here
                    </Link>{' '}
                    for more details.
                </span>
            </p>
        </div>
    );
}

export default CaveatBanner;
